import { render, staticRenderFns } from "./OffCanvasLasku.vue?vue&type=template&id=56d5d45e&scoped=true&"
import script from "./OffCanvasLasku.vue?vue&type=script&lang=js&"
export * from "./OffCanvasLasku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5d45e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d5d45e')) {
      api.createRecord('56d5d45e', component.options)
    } else {
      api.reload('56d5d45e', component.options)
    }
    module.hot.accept("./OffCanvasLasku.vue?vue&type=template&id=56d5d45e&scoped=true&", function () {
      api.rerender('56d5d45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasLasku.vue"
export default component.exports